import { Component } from '@angular/core';

@Component({
  selector: 'app-agility-loading-spinner',
  template: `<p-progressSpinner
    styleClass="custom-spinner"
  ></p-progressSpinner>`,
  styleUrls: ['./agility-loading-spinner.component.scss'],
})
export class AgilityLoadingSpinnerComponent {}
